import {
  DELETE_BRANCH_DATA_SUCCESS,
  DELETE_CITY_DATA_SUCCESS,
  DELETE_WHATSIMAGE_DATA_SUCCESS,
  DELETE_COURSE_DATA_SUCCESS,
  DELETE_DATA_FAILURE,
  DELETE_DATA_REQUEST,
  DELETE_LEAD_DATA_SUCCESS,
  DELETE_SOURCE_DATA_SUCCESS,
  DELETE_STATUS_DATA_SUCCESS,
  DELETE_USER_DATA_SUCCESS,
  DELETE_ADMIN_DATA_SUCCESS,
  GET_BRANCH_DATA_SUCCESS,
  GET_CITY_DATA_SUCCESS,
  GET_WHATSIMAGE_DATA_SUCCESS,
  GET_CONTACT_DATA_SUCCESS,
  GET_COURSE_ANALYTICS_SUCCESS,
  GET_COURSE_DATA_SUCCESS,
  GET_DATA_FAILURE,
  GET_DATA_REQUEST,
  GET_LEAD_COUNT_SUCCESS,
  GET_LEAD_DATA_SUCCESS,
  GET_SINGLE_BRANCH_DATA_SUCCESS,
  GET_SINGLE_CITY_DATA_SUCCESS,
  GET_SINGLE_WHATSIMAGE_DATA_SUCCESS,
  GET_SINGLE_CONTACT_DATA_SUCCESS,
  GET_SINGLE_COURSE_DATA_SUCCESS,
  GET_SINGLE_DATA_FAILURE,
  GET_SINGLE_DATA_REQUEST,
  GET_SINGLE_LEAD_DATA_SUCCESS,
  GET_SINGLE_SOURCE_DATA_SUCCESS,
  GET_SINGLE_STATUS_DATA_SUCCESS,
  GET_SINGLE_USER_DATA_SUCCESS,
  GET_SINGLE_SUPPORT_DATA_SUCCESS,
  GET_SINGLE_ADMIN_DATA_SUCCESS,
  GET_SOURCE_ANALYTICS_SUCCESS,
  GET_SOURCE_DATA_SUCCESS,
  GET_STATUS_DATA_SUCCESS,
  GET_USER_DATA_SUCCESS,
  GET_SUPPORT_DATA_SUCCESS,
  GET_ADMIN_DATA_SUCCESS,
  POST_BRANCH_DATA_SUCCESS,
  POST_CITY_DATA_SUCCESS,
  POST_WHATSIMAGE_DATA_SUCCESS,
  POST_COURSE_DATA_SUCCESS,
  POST_DATA_FAILURE,
  POST_DATA_REQUEST,
  POST_LEAD_DATA_SUCCESS,
  POST_LEAD_ASSIGN_SUCCESS,
  POST_LEAD_LOGS_SUCCESS,
  POST_SIGN_IN_SUCCESS,
  SET_SIGNIN_USER,
  POST_SIGN_OUT_SUCCESS,
  POST_SOURCE_DATA_SUCCESS,
  POST_STATUS_DATA_SUCCESS,
  POST_USER_DATA_SUCCESS,
  POST_SUPPORT_DATA_SUCCESS,
  UPDATE_BRANCH_DATA_SUCCESS,
  UPDATE_SUPPORT_DATA_SUCCESS,
  UPDATE_CITY_DATA_SUCCESS,
  UPDATE_WHATSIMAGE_DATA_SUCCESS,
  UPDATE_COURSE_DATA_SUCCESS,
  UPDATE_DATA_FAILURE,
  UPDATE_DATA_REQUEST,
  UPDATE_LEAD_DATA_SUCCESS,
  UPDATE_SOURCE_DATA_SUCCESS,
  UPDATE_STATUS_DATA_SUCCESS,
  UPDATE_USER_DATA_SUCCESS,
  UPDATE_ADMIN_DATA_SUCCESS,
  POST_SUPER_SIDEMENU,
  POST_TODO_DATA,
  GET_SUPER_ADMIN_REVENUE,
  GET_SUPER_DASHBOARD_TILES,
  GET_SUPER_SIDEMENU,
  GET_SUPER_TODO,
  GET_SUPER_SINGLE_PARTICULAR_ADMIN_REVENUE,
  UPDATE_SUPER_SIDEMENU,
  UPDATE_SUPER_TODO,
  DELETE_SUPER_SIDEMENU,
  DELETE_TODO_DATA,
  GET_SINGLE_SUPER_SIDEMENU,
  GET_SINGLE_SUPER_TODO,
  POST_SIGN_UP_SUCCESS,
  POST_FORGET_PASSWORD_REQUEST,
  POST_FORGET_PASSWORD_SUCCESS,
  POST_PROPOSAL_SUCCESS,
  GET_PROPOSAL_DATA,
  GET_SINGLE_PROPOSAL,
  UPDATE_PROPOSAL_DATA,
  GET_PROPOSAL_GREETING_DATA,
  UPDATE_PROPOSAL_GREETING_DATA,
  GET_SINGLE_PROPOSAL_GREETING,
  POST_GREETING_CATEGORY_SUCCESS,
  GET_GREETING_CATEGORY_DATA,
  DELETE_GREETING_SUCCESS,
  POST_CLIENT_PROPOSAL_EMAIL,
  POST_CATEGORY_SUCCESS,
  POST_EMAIL_TEMPLATE_DATA_SUCCESS,
  GET_EMAIL_TEPLATES_SUCCESS,
  UPDATE_EMAIL_TEMPLATE_DATA,
  DELETE_EMAIL_TEMPLATE_SUCCESS,
  POST_BULK_EMAIL_SEND_DATA_SUCCESS,
  POST_EMAIL_TEMPLATE_CATEGORY_SUCCESS,
  GET_EMAIL_TEMPLATE_CATOGORY_SUCCESS,
  POST_IMAGE_CLOUDINARY_SUCCESS,
  POST_COVER_IMAGE_EMAIL_SUCCESS,
  GET_EMAIL_CAMPAIGN_REPORT,
  POST_WHATSAPP_TEMPLATE_SUCCESS,
  GET_WHATSAPP_TEMPLATE_SUCCESS,
  UPDATE_WHATSAPP_TEMPLATE_DATA,
  DELETE_WHATSAPP_TEMPLATE_SUCCESS,
  POST_SMS_TEMPLATE_SUCCESS,
  GET_SMS_TEMPLATE_SUCCESS,
  UPDATE_SMS_TEMPLATE_DATA,
  DELETE_SMS_TEMPLATE_SUCCESS,
  GET_DEMO_ENQUIRY_SUCCESS,
  UPDATE_DEMO_ENQUIRY_DATA_SUCCESS,
  GET_SINLGE_DEMO_EMQUIRY_DATA_SUCCESS,
  POST_SUPER_USER_DATA_SUCCESS,
  GET_SUPER_USER_DATA_SUCCESS,
  UPDATE_SUPER_USER_DATA_SUCCESS,
  GET_SUPER_GREETING_CATEGORIES_SUCCESS,
  GET_SUPER_PROPOSAL_GREETING_SUCCESS,
  UPDATE_SUPER_PROPOSAL_GREETING_SUCCESS,
  POST_SUPER_BRANCH_SUCCESS,
  GET_SUPER_BRANCH_DATA_SUCCESS,
  UPDATE_SUPER_BRANCH_DATA_SUCCESS,
  POST_SUPER_CITY_DATA_SUCCESS,
  GET_SUPER_CITY_DATA_SUCCESS,
  UPDATE_SUPER_CITY_DATA_SUCCESS,
  GET_SUPER_EMAIL_TEMPLATES_SUCCESS,
  POST_SUPER_EMAIL_TEMPLATE_CATEGORY_SUCCESS,
  GET_SUPER_EMAIL_TEMPLATE_CATOGORY_SUCCESS,
  POST_SUPER_EMAIL_TEMPLATE_DATA_SUCCESS,
  UPDATE_SUPER_EMAIL_TEMPLATE_DATA,
  POST_DEMO_ENQUIRY_DATA_SUCCESS,
  DELETE_PROPOSAL_SUCCESS,
  POST_NAVBAR_CONTENT_SUCCESS,
  GET_NAVBAR_CONTENT_SUCCESS,
  GET_SINGLE_NAVBAR_CONTENT_SUCCESS,
  DELETE_NAVBAR_CONTENT_SUCCESS,
  UPDATE_NAVBAR_CONTENT_SUCCESS,
  POST_LEGAL_CONTENT_SUCCESS,
  GET_LEGAL_CONTENT_SUCCESS,
  GET_SINGLE_LEGAL_CONTENT_SUCCESS,
  GET_PUBLIC_LEGAL_CONTENT_SUCCESS,
  DELETE_LEGAL_CONTENT_SUCCESS,
  UPDATE_LEGAL_CONTENT_SUCCESS,
  POST_CONTACT_ENQUIRY_SUCCESS,
  GET_CONTACT_ENQUIRY_SUCCESS,
  GET_SINGLE_CONTACT_ENQUIRY_SUCCESS,
  DELETE_CONTACT_ENQUIRY_SUCCESS,
  UPDATE_CONTACT_ENQUIRY_SUCCESS,
  GETFOOTERCONTENTSUCCESS,
  GETSINGLEFOOTERCONTENTSUCCESS,
  POSTFOOTERCONTENTSUCCESS,
  DELETEFOOTERCONTENTSUCCESS,
  UPDATEFOOTERCONTENTSUCCESS,
  GET_PROPOSAL_SUMMARY_SUCCESS,
  GET_SUPER_TERMS_CATEGORIES_SUCCESS,
  GET_SUPER_PROPOSAL_TERMS_SUCCESS,
  GET_TERMS_CATEGORY_DATA,
  GET_PROPOSAL_TERMS_DATA,
  POST_PROPOSAL_TERMS_SUCCESS,
  POST_TERMS_CATEGORY_SUCCESS,
  UPDATE_PROPOSAL_TERMS_DATA,
  UPDATE_SUPER_PROPOSAL_TERMS_SUCCESS,
  DELETE_TERMS_SUCCESS,
  GET_SINGLE_PROPOSAL_TERMS,
  CANCEL_PROPOSAL_SUCCESS,
  MARK_PROPOSAL_AS_SENT_SUCCESS,
  GET_LEAD_SUMMARY_SUCCESS,
  GET_PAYMENT_DETAILS_SUCCESS,
  GET_LEAD_FIELD_CONFIG_SUCCESS,
  POST_LEAD_FIELD_CONFIG_SUCCESS,
  POST_ACCOUNT_DATA_SUCCESS,
  GET_ACCOUNT_DATA_SUCCESS,
  UPDATE_ACCOUNT_DATA_SUCCESS,
  DELETE_ACCOUNT_DATA_SUCCESS,
  POST_ADMISSION_DATA_SUCCESS,
  GET_ADMISSION_DATA_SUCCESS,
  UPDATE_ADMISSION_DATA_SUCCESS,
  DELETE_ADMISSION_DATA_SUCCESS,
  SEND_ADMISSION_PAYMENT_REMAINDER_MAIL,
  UPDATE_ADMISSION_PAYMENT_MODE_SUCCESS,
  UPDATE_MANUAL_PAYMENT_SUCCESS,
  GET_SINGLE_ADMISSION_DATA_SUCCESS,
  NOTIFICATIONS_BOOTSTRAP,
  NOTIFICATIONS_NEW,
  NOTIFICATIONS_SET_UNREAD_COUNT,
  NOTIFICATIONS_MARK_READ_LOCAL,
  NOTIFICATIONS_MARK_ALL_READ_LOCAL,
  NOTIFICATIONS_REMOVE_LOCAL,
} from "../types/common.types";
import { initialStates } from "../initialStates/initialStates";
import Cookies from "js-cookie";
// import Cookies from "js-cookie";

//This reducer function tooks the initstate as params and action and retrns the data
//and store it in initialstates and we can use initialstates everywhere in the application...
export const commonReducer = (state = initialStates, action) => {
  switch (action.type) {
    //post cases
    case POST_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
      };
    case POST_FORGET_PASSWORD_REQUEST:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_FORGET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_COURSE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_BRANCH_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_SOURCE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_PROPOSAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_DEMO_ENQUIRY_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_GREETING_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_PROPOSAL_TERMS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };

    case POST_TERMS_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_CLIENT_PROPOSAL_EMAIL:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_EMAIL_TEMPLATE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_SUPER_EMAIL_TEMPLATE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_COVER_IMAGE_EMAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_EMAIL_TEMPLATE_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_BULK_EMAIL_SEND_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_WHATSAPP_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_SMS_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_CITY_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_WHATSIMAGE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_STATUS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_USER_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_SIGN_UP_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_SUPPORT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_SUPER_USER_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_SUPER_BRANCH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_SUPER_CITY_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_SUPER_EMAIL_TEMPLATE_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_LEAD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_LEAD_ASSIGN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_LEAD_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_SUPER_SIDEMENU:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_TODO_DATA:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_IMAGE_CLOUDINARY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_NAVBAR_CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POSTFOOTERCONTENTSUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_SIGN_IN_SUCCESS:
      // Update state
      const newStateSignIn = {
        ...state,
        loading: false,
        error: false,
        success: true,
        // auth: true,
        signinuser: action.payload.userData,
      };

      Cookies.set("signinuser", JSON.stringify(newStateSignIn.signinuser));

      return newStateSignIn;
    case SET_SIGNIN_USER: {
      const updated = action.payload || {};
      const merged = {
        ...state,
        signinuser: {
          ...(state.signinuser || {}),
          ...updated,
        },
      };
      Cookies.set("signinuser", JSON.stringify(merged.signinuser));
      return merged;
    }
    case POST_SIGN_OUT_SUCCESS:
      const newStateLogout = {
        ...state,
        loading: false,
        auth: false,
        error: false,
        success: true,
        signinuser: {},
        notificationBellItems: [],
        notificationUnreadCount: 0,
      };
      Cookies.remove("token");
      Cookies.remove("signinuser");
      return newStateLogout;
    case POST_DATA_FAILURE: {
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
      };
    }
    case POST_LEGAL_CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
    case POST_CONTACT_ENQUIRY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };

    //get cases
    case GET_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
      };
    case GET_COURSE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        courses: action.payload,
      };
    case GET_BRANCH_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        branches: action.payload,
      };
    case GET_SUPER_BRANCH_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        superBranches: action.payload,
      };
    case GET_SOURCE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        sources: action.payload,
      };
    case GET_CITY_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        cities: action.payload,
      };
    case GET_SUPER_CITY_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        superCities: action.payload,
      };
    case GET_DEMO_ENQUIRY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        demoEnquiries: action.payload,
        page: action.page,
        message: action.message,
      };
    case GET_SUPER_GREETING_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        superGreetingCategories: action.payload,
      };
    case GET_SUPER_PROPOSAL_GREETING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        superProposalGreeting: action.payload,
      };
    case GET_PROPOSAL_DATA:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        proposals: action.payload,
        page: action.page,
      };
    case GET_PAYMENT_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        searchedPaymentDetails: action.payload,
      };
    case GET_PROPOSAL_SUMMARY_SUCCESS:
      return {
        ...state,
        proposalSummaryLoading: false,
        error: false,
        proposalSummaryError: true,
        proposalSummary: action.payload,
      };
    case GET_PROPOSAL_GREETING_DATA:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        proposalGreetings: action.payload,
      };
    case GET_GREETING_CATEGORY_DATA:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        greetingCategories: action.payload,
      };
    case GET_PROPOSAL_TERMS_DATA:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        proposalTerms: action.payload,
      };

    case GET_TERMS_CATEGORY_DATA:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        termsCategories: action.payload,
      };

    case GET_SUPER_TERMS_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        superTermsCategories: action.payload,
      };

    case GET_SUPER_PROPOSAL_TERMS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        superProposalTerms: action.payload,
      };
    case GET_EMAIL_TEPLATES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        emailTemplates: action.payload,
      };
    case GET_SUPER_EMAIL_TEMPLATES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        superEmailTemplates: action.payload,
      };

    case GET_EMAIL_TEMPLATE_CATOGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        emailTemplateCategories: action.payload,
      };
    case GET_SUPER_EMAIL_TEMPLATE_CATOGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        superEmailTemplateCategories: action.payload,
      };
    case GET_EMAIL_CAMPAIGN_REPORT:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        emailReport: action.payload,
      };
    case GET_WHATSAPP_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        whatsAppTemplates: action.payload,
      };
    case GET_SMS_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        smsTemplates: action.payload,
      };
    case GET_WHATSIMAGE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        whatsapps: action.payload,
      };
    case GET_CONTACT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        contacts: action.payload,
      };
    case GET_STATUS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        statuses: action.payload,
      };
    case GET_USER_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        users: action.payload,
        page: action.page,
      };
    case GET_SUPPORT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        supports: action.payload,
      };
    case GET_ADMIN_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        admins: action.payload,
        page: action.page,
      };
    case GET_LEAD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        users: action.payload,
      };
    case GET_LEAD_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        leadSummary: action.payload.Data,
      };
    case GET_LEAD_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        leadscount: action.payload,
      };
    case GET_SUPER_ADMIN_REVENUE:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        adminsrevenue: action.payload,
      };

    case GET_SUPER_DASHBOARD_TILES:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        supertiles: action.payload,
      };
    case GET_SUPER_USER_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        superUsers: action.payload,
      };

    case GET_SUPER_SIDEMENU:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        sidemenus: action.payload,
      };

    case GET_SUPER_TODO:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        todos: action.payload,
      };

    case GET_COURSE_ANALYTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        courseanalytics: action.payload,
      };
    case GET_SOURCE_ANALYTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        sourceanalytics: action.payload,
      };
    case GET_DATA_FAILURE: {
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
      };
    }
    case GET_NAVBAR_CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        navbarContents: action.payload,
        page: action.page,
      };

    case GET_LEGAL_CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        legalContents: action.payload,
        page: action.page,
      };
    case GET_CONTACT_ENQUIRY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        contactEnquiries: action.payload,
        contactEnquiryPage: action.page,
      };
    case GETFOOTERCONTENTSUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        footerContents: action.payload,
        footerContentPage: action.page,
      };

    //get single cases
    case GET_SINGLE_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
      };
    case GET_SINGLE_COURSE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        course: action.payload,
      };
    case GET_SINGLE_BRANCH_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        branch: action.payload,
      };
    case GET_SINGLE_SOURCE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        source: action.payload,
      };
    case GET_SINGLE_CITY_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        city: action.payload,
      };
    case GET_SINGLE_WHATSIMAGE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        whatsapp: action.payload,
      };
    case GET_SINGLE_CONTACT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        contact: action.payload,
      };
    case GET_SINGLE_STATUS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        status: action.payload,
      };
    case GET_SINGLE_USER_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        user: action.payload,
      };
    case GET_SINLGE_DEMO_EMQUIRY_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        enquiry: action.payload.enquiry,
      };
    case GET_SINGLE_PROPOSAL:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        proposal: action.payload,
      };
    case GET_SINGLE_PROPOSAL_GREETING:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        proposalGreeting: action.payload,
      };
    case GET_SINGLE_PROPOSAL_TERMS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        singleProposalTerms: action.payload,
      };
    case GET_SINGLE_SUPPORT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        support: action.payload,
      };
    case GET_SUPER_SINGLE_PARTICULAR_ADMIN_REVENUE:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        particularadminrevnue: action.payload,
      };

    case GET_SINGLE_ADMIN_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        admin: action.payload,
      };
    case GET_SINGLE_SUPER_SIDEMENU:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        sidemenu: action.payload,
      };
    case GET_SINGLE_SUPER_TODO:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        todo: action.payload,
      };
    case GET_SINGLE_LEAD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        lead: action.payload.Data,
        logs: action.payload.leadLogss,
        leadLogss: action.payload.leadLogss,
        prevCourses: action.payload.prevCourses,
        prevStatusHistory: action.payload.prevStatusHistory,
        prevFollowups: action.payload.prevFollowups,
      };
    case GET_SINGLE_NAVBAR_CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        navbarContent: action.payload,
      };
    case GET_SINGLE_DATA_FAILURE: {
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
      };
    }

    case GET_SINGLE_LEGAL_CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        legalContent: action.payload.Data,
      };

    case GET_PUBLIC_LEGAL_CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        publicLegalContent: action.payload,
      };
    case GET_SINGLE_CONTACT_ENQUIRY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        contactEnquiry: action.payload,
      };
    case GETSINGLEFOOTERCONTENTSUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        footerContent: action.payload,
      };

    //delete cases
    case DELETE_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
      };
    case DELETE_BRANCH_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        branches: state.branches.filter(
          (branch) => branch._id !== action.payload,
        ),
      };
    case DELETE_COURSE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        courses: state.courses.filter(
          (course) => course._id !== action.payload,
        ),
      };
    case DELETE_SOURCE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        sources: state.sources.filter(
          (source) => source._id !== action.payload,
        ),
      };
    case DELETE_CITY_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        cities: state.cities.filter((city) => city._id !== action.payload),
      };
    case DELETE_WHATSIMAGE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        whatsapps: state.whatsapps.filter(
          (whatsapp) => whatsapp._id !== action.payload,
        ),
      };
    case DELETE_STATUS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        statuses: state.statuses.filter(
          (status) => status._id !== action.payload,
        ),
      };
    case DELETE_PROPOSAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        proposals: state.proposals.filter(
          (proposal) => proposal._id !== action.payload,
        ),
      };
    case DELETE_GREETING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        proposalGreetings: state.proposalGreetings.filter(
          (greeting) => greeting._id !== action.payload,
        ),
      };
    case DELETE_TERMS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        proposalTerms: state.proposalTerms.filter(
          (term) => term._id !== action.payload._id,
        ),
      };
    case DELETE_USER_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        users: state.users.filter((user) => user._id !== action.payload),
      };
    case DELETE_ADMIN_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        admins: state.admins.filter((admin) => admin._id !== action.payload),
      };
    case DELETE_LEAD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        leads: state.leads.filter((leads) => leads._id !== action.payload),
      };
    case DELETE_SUPER_SIDEMENU:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        sidemenus: state.sidemenus.filter(
          (sidemenu) => sidemenu._id !== action.payload,
        ),
      };
    case DELETE_TODO_DATA:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        todos: state.todos.filter((todo) => todo._id !== action.payload),
      };
    case DELETE_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        emailTemplates: state.emailTemplates.filter(
          (template) => template._id !== action.payload._id,
        ),
      };
    case DELETE_WHATSAPP_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        whatsAppTemplates: state.whatsAppTemplates.filter(
          (template) => template._id !== action.payload._id,
        ),
      };
    case DELETE_SMS_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        smsTemplates: state.smsTemplates.filter(
          (template) => template._id !== action.payload._id,
        ),
      };

    case DELETE_NAVBAR_CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        navbarContents: state.navbarContents?.filter(
          (content) => content._id !== action.payload,
        ),
      };
    case DELETE_DATA_FAILURE: {
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
      };
    }
    case DELETE_LEGAL_CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        legalContents: state.legalContents.filter(
          (content) => content._id !== action.payload,
        ),
      };
    case DELETE_CONTACT_ENQUIRY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        contactEnquiries: state.contactEnquiries.filter(
          (enquiry) => enquiry._id !== action.payload,
        ),
      };
    case DELETEFOOTERCONTENTSUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        footerContents: state.footerContents?.filter(
          (content) => content._id !== action.payload,
        ),
      };

    //update cases
    case UPDATE_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
      };
    case UPDATE_BRANCH_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        branches: state.branches.map((branch) =>
          branch._id === action.payload._id ? action.payload : branch,
        ),
      };
    case UPDATE_SUPPORT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        supports: state.supports.map((support) =>
          support._id === action.payload._id ? action.payload : support,
        ),
      };
    case UPDATE_COURSE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        courses: state.courses.map((course) =>
          course._id === action.payload._id ? action.payload : course,
        ),
      };

    case UPDATE_SOURCE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        sources: state.sources.map((source) =>
          source._id === action.payload._id ? action.payload : source,
        ),
      };
    case UPDATE_CITY_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        cities: state.cities.map((city) =>
          city._id === action.payload._id ? action.payload : city,
        ),
      };
    case UPDATE_WHATSIMAGE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        whatsapps: state.whatsapps.map((whatsapp) =>
          whatsapp._id === action.payload._id ? action.payload : whatsapp,
        ),
      };
    case UPDATE_STATUS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        statuses: state.statuses.map((status) =>
          status._id === action.payload._id ? action.payload : status,
        ),
      };
    case UPDATE_USER_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        users: state.users.map((user) =>
          user._id === action.payload._id ? action.payload : user,
        ),
      };
    case UPDATE_ADMIN_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        admins: state.admins.map((admin) =>
          admin._id === action.payload._id ? action.payload : admin,
        ),
      };
    case UPDATE_LEAD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        leads: state.leads.map((lead) =>
          lead._id === action.payload._id ? action.payload : lead,
        ),
      };
    case UPDATE_PROPOSAL_DATA:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        proposals: state?.proposals?.map((proposal) =>
          proposal?._id === action?.payload?.Data?._id
            ? action?.payload?.Data
            : proposal,
        ),
      };
    case MARK_PROPOSAL_AS_SENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        proposals: state.proposals.map((proposal) =>
          proposal._id === action.payload.Data._id
            ? action.payload.Data
            : proposal,
        ),
      };

    case CANCEL_PROPOSAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        proposals: state.proposals.map((proposal) =>
          proposal._id === action.payload.Data._id
            ? action.payload.Data
            : proposal,
        ),
      };
    case UPDATE_PROPOSAL_GREETING_DATA:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        proposalGreetings: state.proposalGreetings.map((greeting) =>
          greeting._id === action.payload.Data._id
            ? action.payload.Data
            : greeting,
        ),
      };
    case UPDATE_PROPOSAL_TERMS_DATA:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        proposalTerms: state.proposalTerms.map((term) =>
          term._id === action.payload.Data._id ? action.payload.Data : term,
        ),
      };
    case UPDATE_SUPER_PROPOSAL_TERMS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        superProposalTerms: state.superProposalTerms.map((term) =>
          term._id === action.payload.Data._id ? action.payload.Data : term,
        ),
      };
    case UPDATE_DEMO_ENQUIRY_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
      };

    case UPDATE_EMAIL_TEMPLATE_DATA:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        emailTemplates: state.emailTemplates.map((template) =>
          template._id === action.payload.Data._id ? action.payload : template,
        ),
      };
    case UPDATE_SUPER_EMAIL_TEMPLATE_DATA:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        superEmailTemplates: state.superEmailTemplates.map((template) =>
          template._id === action.payload.Data._id ? action.payload : template,
        ),
      };
    case UPDATE_WHATSAPP_TEMPLATE_DATA:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        whatsAppTemplates: state.whatsAppTemplates.map((template) =>
          template._id === action.payload.Data._id ? action.payload : template,
        ),
      };
    case UPDATE_SMS_TEMPLATE_DATA:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        smsTemplates: state.smsTemplates.map((template) =>
          template._id === action.payload.Data._id ? action.payload : template,
        ),
      };
    case UPDATE_SUPER_USER_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        superUsers: state.superUsers?.map((user) =>
          user._id === action.payload.Data._id ? action.payload : user,
        ),
      };
    case UPDATE_SUPER_BRANCH_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        superBranches: state?.superBranches?.map((branch) =>
          branch._id === action.payload.Data._id ? action.payload : branch,
        ),
      };
    case UPDATE_SUPER_CITY_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        superCities: state.superCities.map((city) =>
          city._id === action.payload.Data._id ? action.payload : city,
        ),
      };
    case UPDATE_SUPER_PROPOSAL_GREETING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        superProposalGreeting: state.superProposalGreeting.map((greeting) =>
          greeting._id === action.payload.Data._id ? action.payload : greeting,
        ),
      };
    case UPDATE_SUPER_SIDEMENU:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        sidemenus: state.sidemenus.map((sidemenu) =>
          sidemenu._id === action.payload._id ? action.payload : sidemenu,
        ),
      };
    case UPDATE_SUPER_TODO:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        todos: state.todos.map((todo) =>
          todo._id === action.payload._id ? action.payload : todo,
        ),
      };
    case UPDATE_NAVBAR_CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        navbarContents: state.navbarContents?.map((content) =>
          content._id === action.payload.Data._id
            ? action.payload.Data
            : content,
        ),
      };

    case UPDATE_LEGAL_CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        legalContents: state.legalContents.map((content) =>
          content._id === action.payload.Data._id
            ? action.payload.Data
            : content,
        ),
      };
    case UPDATE_CONTACT_ENQUIRY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        contactEnquiries: state.contactEnquiries.map((enquiry) =>
          enquiry._id === action.payload._id ? action.payload : enquiry,
        ),
      };
    case UPDATEFOOTERCONTENTSUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        footerContents: state.footerContents?.map((content) =>
          content._id === action.payload._id ? action.payload : content,
        ),
      };
    // case UPDATE_LOGCOURSE_DATA_SUCCESS:
    //   return {
    //     ...state,
    //     loading: false,
    //     error: false,
    //     success: true,
    //     lead: state.lead.map((lead) =>
    //       lead._id === action.payload._id ? action.payload : lead
    //     ),
    //   };
    case UPDATE_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
      };

    // --- CONFIG CASES ---
    case GET_LEAD_FIELD_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        // The backend returns { Data: { fields: [] } }
        leadFieldConfig: action.payload || { fields: [] },
      };

    case POST_LEAD_FIELD_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        // Update local state with the saved config
        leadFieldConfig: action.payload.Data,
      };

    // --- ACCOUNT CASES ---
    case POST_ACCOUNT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
      };

    case GET_ACCOUNT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        // Handle pagination: if payload has docs, use that, else use payload directly
        accounts: action.payload.docs || action.payload,
        error: false,
      };

    case UPDATE_ACCOUNT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        // Optimistic update
        accounts: state.accounts.map((account) =>
          account._id === action.payload.Data._id
            ? action.payload.Data
            : account,
        ),
      };

    case DELETE_ACCOUNT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        // Remove deleted item from state
        accounts: state.accounts.filter(
          (account) => account._id !== action.payload?._id, // Adjust based on what delete API returns
        ),
      };

    // --- ADMISSION CASES ---
    case POST_ADMISSION_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
      };

    case GET_ADMISSION_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        // The controller returns { Data: { docs: [...] } } because of pagination
        admissions: action.payload.docs || action.payload,
        error: false,
      };

    case UPDATE_ADMISSION_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        singleAdmission: action.payload.Data || action.payload,
        admissions: state.admissions.map((adm) =>
          adm._id === action.payload.Data._id ? action.payload.Data : adm,
        ),
      };

    case DELETE_ADMISSION_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        admissions: state.admissions.filter(
          (adm) => adm._id !== action.payload?._id,
        ),
      };

    // --- ADMISSION UPDATE CASES ---
    case SEND_ADMISSION_PAYMENT_REMAINDER_MAIL:
      // Typically, sending a mail doesn't change the state data, but if it did:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case UPDATE_ADMISSION_PAYMENT_MODE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        singleAdmission: action.payload.Data || action.payload,
        // Update the specific admission in the list
        admissions: state.admissions.map((adm) =>
          adm._id === action.payload.Data._id ? action.payload.Data : adm,
        ),
      };

    case UPDATE_MANUAL_PAYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        // Update the specific admission in the list
        admissions: state.admissions.map((adm) =>
          adm._id === action.payload.Data._id ? action.payload.Data : adm,
        ),
      };

    case GET_SINGLE_ADMISSION_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        singleAdmission: action.payload, // Store single admission data
        error: false,
      };

    case "CLEAR_SINGLE_ADMISSION":
      return {
        ...state,
        singleAdmission: null,
      };

    case NOTIFICATIONS_BOOTSTRAP:
      return {
        ...state,
        notificationBellItems: action.payload.items || [],
        notificationUnreadCount:
          typeof action.payload.unreadCount === "number"
            ? action.payload.unreadCount
            : state.notificationUnreadCount,
      };

    case NOTIFICATIONS_NEW: {
      const n = action.payload;
      if (!n || !n._id) return state;
      const prev = state.notificationBellItems || [];
      const withoutDup = prev.filter((x) => String(x._id) !== String(n._id));
      const items = [n, ...withoutDup].slice(0, 15);
      return {
        ...state,
        notificationBellItems: items,
      };
    }

    case NOTIFICATIONS_SET_UNREAD_COUNT:
      return {
        ...state,
        notificationUnreadCount:
          typeof action.payload?.count === "number"
            ? action.payload.count
            : state.notificationUnreadCount,
      };

    case NOTIFICATIONS_MARK_READ_LOCAL: {
      const id = String(action.payload?.id || "");
      const items = (state.notificationBellItems || []).map((x) =>
        String(x._id) === id ? { ...x, isRead: true } : x,
      );
      return { ...state, notificationBellItems: items };
    }

    case NOTIFICATIONS_MARK_ALL_READ_LOCAL:
      return {
        ...state,
        notificationBellItems: (state.notificationBellItems || []).map((x) => ({
          ...x,
          isRead: true,
        })),
        notificationUnreadCount: 0,
      };

    case NOTIFICATIONS_REMOVE_LOCAL: {
      const id = String(action.payload?.id || "");
      const removed = (state.notificationBellItems || []).find(
        (x) => String(x._id) === id,
      );
      const items = (state.notificationBellItems || []).filter(
        (x) => String(x._id) !== id,
      );
      let unread = state.notificationUnreadCount || 0;
      if (removed && !removed.isRead) unread = Math.max(0, unread - 1);
      return { ...state, notificationBellItems: items, notificationUnreadCount: unread };
    }

    default:
      return state;
  }
};
